export default __webpack_public_path__ + "static/media/home-left-side.f2a26eea.svg";